import { Component, OnInit } from '@angular/core';

import {
  RouterService,
  StateService,
  User,
} from 'projects/shared/src/public-api';
import { AlertController, ModalController } from '@ionic/angular';
import { UserFormComponent } from 'projects/shared/src/lib/user-form/user-form.component';
@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: false
})
export class UserComponent implements OnInit {
  constructor(
    public modalController: ModalController,

    public routerService: RouterService
  ) {}

  ngOnInit() {}

  async createNewUser() {
    const modal = await this.modalController.create({
      component: UserFormComponent,
    });
    modal.present();
    //this.selectedDate = new Date();
    const { data, role } = await modal.onWillDismiss();

    /*if (role === 'confirm') {
         
        }*/
  }
}
